import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultGeneral = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 150,
	height: 102,
	viewBox: "0 0 150 102",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143.713 18C147.185 18 150 20.2833 150 23.1C150 25.9167 147.185 28.2 143.713 28.2H107.784C111.257 28.2 114.072 30.4833 114.072 33.3C114.072 36.1167 111.257 38.4 107.784 38.4H127.545C131.017 38.4 133.832 40.6833 133.832 43.5C133.832 46.3167 131.017 48.6 127.545 48.6H118.407C114.028 48.6 110.479 50.8833 110.479 53.7C110.479 55.5778 112.275 57.2778 115.868 58.8C119.341 58.8 122.156 61.0833 122.156 63.9C122.156 66.7167 119.341 69 115.868 69H41.3174C37.8449 69 35.0299 66.7167 35.0299 63.9C35.0299 61.0833 37.8449 58.8 41.3174 58.8H6.28743C2.81498 58.8 0 56.5167 0 53.7C0 50.8833 2.81498 48.6 6.28743 48.6H42.2156C45.688 48.6 48.503 46.3167 48.503 43.5C48.503 40.6833 45.688 38.4 42.2156 38.4H19.7605C16.288 38.4 13.4731 36.1167 13.4731 33.3C13.4731 30.4833 16.288 28.2 19.7605 28.2H55.6886C52.2162 28.2 49.4012 25.9167 49.4012 23.1C49.4012 20.2833 52.2162 18 55.6886 18H143.713ZM143.713 38.4C147.185 38.4 150 40.6833 150 43.5C150 46.3167 147.185 48.6 143.713 48.6C140.24 48.6 137.425 46.3167 137.425 43.5C137.425 40.6833 140.24 38.4 143.713 38.4Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M95.3499 10.6266L102.629 63.7138L103.283 69.0398C103.493 70.7556 102.273 72.3173 100.557 72.5279L54.7337 78.1544C53.018 78.365 51.4563 77.1449 51.2456 75.4291L44.1907 17.9718C44.0854 17.1139 44.6955 16.3331 45.5533 16.2277C45.5588 16.2271 45.5642 16.2264 45.5696 16.2258L49.3713 15.7994M52.4458 15.4545L56.0352 15.0519Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.0929 10.5247C96.0367 10.1144 95.6584 9.82731 95.248 9.88358C94.8376 9.93984 94.5506 10.3181 94.6068 10.7285L95.3499 10.6266L96.0929 10.5247ZM102.629 63.7138L103.373 63.6224L103.372 63.612L102.629 63.7138ZM103.283 69.0398L104.027 68.9484L103.283 69.0398ZM100.557 72.5279L100.649 73.2723L100.557 72.5279ZM54.7337 78.1544L54.8251 78.8988L54.7337 78.1544ZM51.2456 75.4291L51.99 75.3377L51.2456 75.4291ZM44.1907 17.9718L44.9351 17.8804L44.1907 17.9718ZM45.5696 16.2258L45.6532 16.9711L45.5696 16.2258ZM49.4549 16.5447C49.8665 16.4985 50.1628 16.1274 50.1166 15.7158C50.0705 15.3041 49.6993 15.0079 49.2877 15.054L49.3713 15.7994L49.4549 16.5447ZM52.3622 14.7092C51.9505 14.7554 51.6543 15.1265 51.7004 15.5381C51.7466 15.9498 52.1177 16.246 52.5294 16.1999L52.4458 15.4545L52.3622 14.7092ZM56.1188 15.7972C56.5304 15.7511 56.8267 15.3799 56.7805 14.9683C56.7343 14.5567 56.3632 14.2604 55.9515 14.3066L56.0352 15.0519L56.1188 15.7972ZM95.3499 10.6266L94.6068 10.7285L101.886 63.8157L102.629 63.7138L103.372 63.612L96.0929 10.5247L95.3499 10.6266ZM102.629 63.7138L101.884 63.8052L102.538 69.1312L103.283 69.0398L104.027 68.9484L103.373 63.6224L102.629 63.7138ZM103.283 69.0398L102.538 69.1312C102.698 70.4359 101.771 71.6233 100.466 71.7835L100.557 72.5279L100.649 73.2723C102.776 73.0112 104.288 71.0753 104.027 68.9484L103.283 69.0398ZM100.557 72.5279L100.466 71.7835L54.6423 77.41L54.7337 78.1544L54.8251 78.8988L100.649 73.2723L100.557 72.5279ZM54.7337 78.1544L54.6423 77.41C53.3377 77.5701 52.1502 76.6424 51.99 75.3377L51.2456 75.4291L50.5012 75.5205C50.7623 77.6474 52.6982 79.1599 54.8251 78.8988L54.7337 78.1544ZM51.2456 75.4291L51.99 75.3377L44.9351 17.8804L44.1907 17.9718L43.4463 18.0632L50.5012 75.5205L51.2456 75.4291ZM44.1907 17.9718L44.9351 17.8804C44.8803 17.4336 45.198 17.027 45.6447 16.9721L45.5533 16.2277L45.4619 15.4833C44.1929 15.6391 43.2905 16.7942 43.4463 18.0632L44.1907 17.9718ZM45.5533 16.2277L45.6447 16.9721C45.6476 16.9718 45.6504 16.9715 45.6532 16.9711L45.5696 16.2258L45.486 15.4805C45.478 15.4814 45.47 15.4823 45.4619 15.4833L45.5533 16.2277ZM45.5696 16.2258L45.6532 16.9711L49.4549 16.5447L49.3713 15.7994L49.2877 15.054L45.486 15.4805L45.5696 16.2258ZM52.4458 15.4545L52.5294 16.1999L56.1188 15.7972L56.0352 15.0519L55.9515 14.3066L52.3622 14.7092L52.4458 15.4545Z",
			fill: "#91A0B1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M93.3683 13.9673L99.9566 62.0786L100.549 66.9052C100.74 68.4602 99.6494 69.8736 98.1129 70.0623L57.0768 75.1009C55.5403 75.2895 54.1399 74.1819 53.949 72.627L47.6246 21.1189C47.49 20.0225 48.2696 19.0247 49.366 18.8901L54.0108 18.3197",
			fill: "#F8F8F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62 0.75H96.8633C97.7211 0.75 98.5445 1.08905 99.1533 1.69336L109.29 11.7559C109.904 12.3659 110.25 13.1958 110.25 14.0615V62C110.25 63.7949 108.795 65.25 107 65.25H62C60.2051 65.25 58.75 63.7949 58.75 62V4C58.75 2.20507 60.2051 0.75 62 0.75Z",
			fill: "white",
			stroke: "#91A0B1",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98 1V10.5338C98 11.8958 98.9828 13 100.195 13H106",
			stroke: "#91A0B1",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67 53H87.5581M67 13H87.5581H67ZM67 22.4118H101H67ZM67 32.6078H101H67ZM67 42.8039H101H67Z",
			stroke: "#91A0B1",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_13283_14588)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 91,
					y: 41,
					width: 37,
					height: 37,
					rx: 18.5,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.071 63.5279L113.043 59.5L117.071 55.4722C117.877 54.6667 117.966 53.3241 117.071 52.429C116.266 51.6234 114.923 51.5339 114.028 52.429L110 56.4568L105.972 52.429C105.167 51.6234 103.824 51.5339 102.929 52.429C102.034 53.324 102.034 54.5772 102.929 55.4722L106.957 59.5L102.929 63.5279C102.123 64.3334 102.034 65.676 102.929 66.5711C103.734 67.3767 105.077 67.4662 105.972 66.5711L110 62.5433L114.028 66.5711C114.833 67.3767 116.176 67.4662 117.071 66.5711C117.966 65.676 117.877 64.3334 117.071 63.5279Z",
					fill: "url(#paint0_linear_13283_14588)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78 88.72C78 87.9515 78.3051 87.183 78.9917 86.5682L91.7309 73.734L91.4258 73.2729C88.3745 69.1229 86.7725 64.2813 86.7725 59.3628C86.7725 53.4453 89.1373 47.5277 93.2566 43.1472C97.6047 38.5361 103.479 36 109.886 36C122.626 36 133 46.4518 133 59.286C133 68.047 128.423 75.7321 120.642 79.8821C112.938 83.9552 103.936 83.4173 96.6893 78.4219L96.2316 78.1145L83.4161 91.0256C82.1193 92.332 80.8225 92.0246 80.1359 91.7941C78.9154 91.1793 78 89.9496 78 88.72ZM126.669 59.286C126.669 49.9101 119.117 42.3787 109.886 42.3787C99.3592 42.3787 93.0277 51.0629 93.0277 59.5165C93.0277 64.6656 95.3162 69.3535 99.4355 72.6581C104.47 76.7312 111.259 77.4229 117.133 74.5794C123.007 71.659 126.669 65.8183 126.669 59.286Z",
					fill: "url(#paint1_linear_13283_14588)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_13283_14588",
				x: 70,
				y: 30,
				width: 71,
				height: 72,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.815686 0 0 0 0 0.815686 0 0 0 0 0.815686 0 0 0 1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_13283_14588"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_13283_14588",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_13283_14588",
				x1: 102.929,
				y1: 66.5711,
				x2: 117.071,
				y2: 52.429,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#91A0B1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5B7086"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_13283_14588",
				x1: 86.25,
				y1: 82.6667,
				x2: 141.099,
				y2: 45.6187,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#91A0B1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#465C73"
				})]
			})
		] })
	]
});
export default SvgNoResultGeneral;
